module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAYCAMAAAC/Wk/yAAAAM1BMVEUAmZn///+AzMxAs7PA5uYgpqbg8/PQ7OwQn58wrKzw+flgv79QubmQ09Nwxsaw39+g2dnuQZlqAAAAnklEQVQoz92Syw4CIQxFubTlNczo/3+t5REZHGXhyngWBNKT27TB/BKBwqJKtiF6BdX34CxuXPCgLlqceJM7xFpFCbNfiozKEK0C1oNnMd2JaOP4FFmB08NNouAwnXXrDM+FuBLn9VxbL6fe3WWYKRfSRc+rPQaPHivYP4miTTxcFy1iE4VyekmEknIXE5smHgBui28WYxtOAhGZ/+MB5loDihSioPAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-quote.png
// module id = 58hR
// module chunks = 1